import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SessionStateContextProps {
    isSessionRunning: boolean;
    setIsSessionRunning: (value: boolean) => void;
}

const SessionStateContext = createContext<SessionStateContextProps | undefined>(undefined);

export const SessionStateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isSessionRunning, setIsSessionRunning] = useState(false);

    return (
        <SessionStateContext.Provider value={{ isSessionRunning, setIsSessionRunning }}>
            {children}
        </SessionStateContext.Provider>
    );
};

export const useSessionState = (): SessionStateContextProps => {
    const context = useContext(SessionStateContext);
    if (!context) {
        throw new Error('useSessionState must be used within a SessionStateProvider');
    }
    return context;
};
